import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StoneClarityForm from '../../../../components/masters/stoneAttribute/stoneClarity/StoneClarityForm';
import StoneClarityTable from '../../../../components/masters/stoneAttribute/stoneClarity/StoneClarityTable';
import { fetchStoneClarities, addStoneClarity, updateStoneClarity, deleteStoneClarity, setStoneClarityEdit, clearStoneClarityEdit } from '../../../../redux/actions/masters/stoneAttribute/stoneClarity/stoneClarityAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .stone-clarity-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .stone-clarity-form, .stone-clarity-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const StoneClarityPage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingStoneClarity, formSuccess, formError } = useSelector(state => state.stoneClarity || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchStoneClarities());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearStoneClarityEdit());
  };

  const handleSubmit = async (form) => {
    if (editingStoneClarity && editingStoneClarity.stone_clarity_id) {
      await dispatch(updateStoneClarity(editingStoneClarity.stone_clarity_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addStoneClarity(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (stoneClarity) => {
    dispatch(setStoneClarityEdit(stoneClarity));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteStoneClarity(id));
  };

  const handleCancel = () => {
    dispatch(clearStoneClarityEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      sc => sc.stone_clarity_code === code && (!excludeId || sc.stone_clarity_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="stone-clarity-flex">
        <div style={tableContainer} className="stone-clarity-table">
          <StoneClarityTable
            onNew={handleFormReset}
            stoneClarities={list}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="stone-clarity-form">
          <StoneClarityForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingStoneClarity={editingStoneClarity}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default StoneClarityPage; 